import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { classNames } from "@via/utils/helpers";
import { useState } from "react";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  bgColor?: string;
  textColor?: string;
  initialOpen?: boolean;
  testId?: string;
}

export const Accordion = ({
  title,
  children,
  bgColor = "bg-indigo-500",
  textColor = "text-white",
  initialOpen = false,
  testId = "",
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mb-4 overflow-hidden rounded-lg border border-gray-300">
      <div
        className={classNames(
          "flex cursor-pointer items-center justify-between",
          "px-4 py-2",
          bgColor,
          textColor
        )}
        onClick={toggleAccordion}
        data-testid={testId}>
        <h2 className="font-semibold">{title}</h2>
        <span>
          {isOpen ? (
            <MinusIcon className="h-5 w-5" />
          ) : (
            <PlusIcon className="h-5 w-5" />
          )}
        </span>
      </div>
      {isOpen && <div className="bg-gray-100 px-4 py-2">{children}</div>}
    </div>
  );
};
